import type { LlmSubblocksTitleTypes, ProductCardLlmBlockTypes } from '@/common/api/client/types.gen'
import { BLOCK_SECTION_TITLE } from './scoreColors'

export const CRITERIA_TITLE_LABELS: Record<LlmSubblocksTitleTypes, string> = {
    PLUSES: 'Плюсы',
    MINUSES: 'Минусы',
    WHAT_ADD: 'Что добавить',
    WHAT_FIX: 'Что исправить',
    INCREASE_CLICKABILITY: 'Как повысить привлекательность и кликабельность',
    EMPTY_TITLE: '',
    VIDEO_COVER: 'Видеообложка',
    HERO_PACKSHOT: 'Hero packshot',
    SIMPLE_ECOM_PACKSHOT: 'Простой e-compact shot',
    CHARACTERISTICS: 'Характеристики',
    LIFESTYLE_EMOTIONAL: 'Lifestyle фото',
    ADVANTAGES_BENEFITS: 'УТП',
    SKU_VARIANTS: 'Варианты товаров',
    INSTRUCTION: 'Инструкция',
    COMPONENTS: 'Компоненты',
    CROSS_SELL: 'Кросс-продажи',
    BRAND_COMMUNICATION: 'Бренд-коммуникация',
    VIDEO: 'Видео',
    PHOTO_3D: '3D-модель',
    SIMPLE_RICH_CONTENT: 'Простой рич-контент',
    COMPLEX_RICH_CONTENT: 'Сложный рич-контент',
    COMPOSITION: 'Композиция',
    CHARACTERISTICS_KEY: 'Характеристики (ключевые)',
    CLAIMS_AWARDS: 'Награды',
    SKU_VARIATIONS: 'Вариации',
    HOW_TO_US: 'Как использовать',
    SCAN_EASINESS: 'Лёгкость просмотра',
    READ_EASINESS: 'Читаемость',
    BRAND: 'Бренд',
    PRODUCT_MODEL: 'Модель продукта',
    DIMENSIONS_VOLUME_QTY: 'Размеры/объём/количество',
    MAIN_USP: 'Главное УТП',
    IMPORTANT_INFORMATION: 'Важная информация',
    HOW_TO_USE: 'Инструкция',
    SELLING_POWER: 'Продающая сила',
}

export const getBlockTitle = (blockType: ProductCardLlmBlockTypes, title?: string | null) =>
    title?.trim() || BLOCK_SECTION_TITLE[blockType] || blockType

export const getCriteriaLabel = (
    title: string | null | undefined,
    titleType: LlmSubblocksTitleTypes,
    criteriaName: string
) => title?.trim() || CRITERIA_TITLE_LABELS[titleType] || criteriaName
